import { RouteObject } from "react-router-dom";
import RequireActiveAccount from "../../components/router/require-active-account";

import SettingsView from ".";
import AccountSettings from "./accounts";
import DisplaySettings from "./display";
import LightningSettings from "./lightning";
import MailboxesView from "./mailboxes";
import MediaServersView from "./media-servers";
import MessagesSettings from "./messages";
import MutesSettings from "./mutes";
import AppRelaysView from "./relays";
import ProfileSettingsView from "./profile";

export default [
  {
    element: <SettingsView />,
    children: [
      { index: true, Component: DisplaySettings },
      { path: "display", Component: DisplaySettings },
      {
        path: "accounts",
        element: (
          <RequireActiveAccount>
            <AccountSettings />
          </RequireActiveAccount>
        ),
      },
      {
        path: "profile",
        element: (
          <RequireActiveAccount>
            <ProfileSettingsView />
          </RequireActiveAccount>
        ),
      },
      { path: "mailboxes", Component: MailboxesView },
      { path: "media-servers", Component: MediaServersView },
      { path: "relays", Component: AppRelaysView },
      { path: "mutes", Component: MutesSettings },
      { path: "lightning", Component: LightningSettings },
      { path: "messages", Component: MessagesSettings },
    ],
  },
] satisfies RouteObject[];
